import { ResourceLink } from '@admin/dashboard/types/dashboard'
import { T } from '@transifex/react'

export const resourceLinks: ResourceLink[] = [
  {
    key: 'support-articles',
    title: <T _str="Support articles" />,
    description: (
      <T _str="Step-by-step guides and best practices to help you get the most out of your program features" />
    ),
    url: 'https://kudosng.zendesk.com/hc/en-us/categories/38790115142413',
  },
  {
    key: 'templates',
    title: <T _str="Template library" />,
    description: <T _str="Ready-made templates for announcements, awards, and incentives" />,
    url: 'https://kudosng.zendesk.com/hc/en-us/sections/38790390973581-Template-Library',
  },
  {
    key: 'graphic-library',
    title: <T _str="Graphic library" />,
    description: (
      <T _str="Downloadable banners and badges for general themes, holidays, and special occasions" />
    ),
    url: 'https://kudosng.zendesk.com/hc/en-us/sections/38790373193741-Graphic-Library',
  },
]
